module.exports = __webpack_public_path__ + "img/IMG_8982.2eaf39f4.jpg";